// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "custom/Navbars/DefaultNavbar";
import DefaultFooter from "custom/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function PrivacyPage() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/support/contact-us",
          label: "Contáctanos",
          color: "dark",
        }}
        sticky
      />
      <MKBox component="section" pt={20} pb={12}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="dark"
                  borderRadius="lg"
                  coloredShadow="dark"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Privacidad y Política
                  </MKTypography>
                  <MKTypography variant="body2" color="white" opacity={0.8}>
                    Última modificación: 15 de septiembre de 2023
                  </MKTypography>
                </MKBox>
                <MKBox pb={6} px={6}>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Introducción
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    En PWNCAT, la protección de la privacidad de nuestros visitantes es nuestra máxima prioridad.
                    Esta Política de Privacidad describe las categorías de datos que recopilamos y cómo los utilizamos
                    en el contexto de nuestros servicios de ciberseguridad ofensiva.
                    <br />
                    <br />
                    Si tienes alguna pregunta o necesitas más aclaraciones sobre nuestra Política de Privacidad,
                    no dudes en contactarnos por correo electrónico a
                    <MKTypography
                      variant="body2"
                      color="info"
                      component="a"
                      href="mailto:privacy@pwncat.com"
                      target="_blank"
                      rel="noreferrer"
                      sx={{ "&:hover": { color: ({ palette: { info } }) => info.main } }}
                    >
                      &nbsp;privacy@pwncat.com
                    </MKTypography>
                    .
                    <br />
                    <br />
                    Esta política de privacidad se refiere exclusivamente a nuestras operaciones en línea y se aplica a los visitantes
                    del sitio web de PWNCAT en relación con los datos que proporcionan o comparten. No se extiende a los datos
                    recopilados fuera de línea o a través de otros medios.
                  </MKTypography>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Recopilación y Uso de Datos
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    En PWNCAT, recopilamos y procesamos varios tipos de datos con el propósito de proporcionar servicios de
                    ciberseguridad ofensiva.
                  </MKTypography>
                  <br />
                  <MKTypography variant="body2" color="text" align="justify">
                    Estos datos pueden incluir:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Información personal como nombres y detalles de contacto para la comunicación y gestión de cuentas.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Información técnica relacionada con tus interacciones con nuestro sitio web y servicios.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Datos de uso para mejorar nuestro sitio web y servicios.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text" align="justify">
                    Utilizamos estos datos para mejorar nuestros servicios de ciberseguridad ofensiva, personalizar las experiencias de los usuarios
                    y garantizar la seguridad de nuestra plataforma. Tus datos no se venderán ni compartirán con terceros sin
                    tu consentimiento, excepto cuando sea requerido por la ley.
                  </MKTypography>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Gestión de tu Información
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    A menos que se indique explícitamente lo contrario, todos los derechos de propiedad intelectual sobre el contenido de PWNCAT,
                    incluidos materiales y recursos, son propiedad de PWNCAT y/o sus licenciantes. Estos derechos de propiedad
                    intelectual están protegidos y reservados. Se te concede acceso y permiso para utilizar el contenido de PWNCAT
                    únicamente para uso personal, respetando las limitaciones descritas en estos términos y condiciones.
                  </MKTypography>
                  <br />
                  <MKTypography variant="body2" color="text" align="justify">
                    No debes:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Republicar materiales de PWNCAT.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Vender, alquilar o sublicenciar materiales de PWNCAT.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Reproducir, duplicar o copiar materiales de PWNCAT.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Redistribuir contenido de PWNCAT.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Contenido Generado por el Usuario
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    Ciertas secciones de nuestro sitio web permiten a los usuarios publicar e intercambiar opiniones e información
                    en áreas designadas. PWNCAT no participa en la filtración, edición, publicación o
                    revisión del contenido generado por los usuarios antes de que aparezca en el sitio web. Los comentarios y opiniones
                    expresados por los usuarios no representan la postura oficial de PWNCAT, sus agentes o afiliados.
                    Los comentarios reflejan únicamente los puntos de vista de las personas que los publican.
                  </MKTypography>
                  <br />
                  <MKTypography variant="body2" color="text" align="justify">
                    En la medida en que lo permitan las leyes aplicables, PWNCAT renuncia a la responsabilidad por el contenido generado por los usuarios
                    o cualquier responsabilidad, daños o gastos resultantes del uso, publicación o
                    visibilidad de dicho contenido en este sitio web.
                  </MKTypography>
                  <br />
                  <MKTypography variant="body2" color="text" align="justify">
                    PWNCAT se reserva el derecho de monitorear todo el contenido generado por los usuarios y eliminar cualquier contenido que pueda
                    considerarse inapropiado, ofensivo o en violación de estos Términos y Condiciones.
                  </MKTypography>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Seguridad
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    En PWNCAT, tomamos en serio la seguridad de tus datos y tus interacciones en línea. Empleamos rigurosas
                    medidas de seguridad para proteger tu información y mantener la confidencialidad e integridad de
                    nuestros servicios. Aquí hay algunos aspectos clave de nuestras prácticas de seguridad:
                  </MKTypography>
                  <br />
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text">
                        Cifrado de Datos: Utilizamos protocolos de cifrado estándar de la industria para asegurar la transmisión de
                        datos entre tu dispositivo y nuestros servidores. Esto garantiza que tu información personal y sensible
                        permanezca confidencial.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Responsabilidad del Usuario: Aunque nos esforzamos por proteger tus datos, también te animamos a que tomes
                        responsabilidad por tu propia seguridad. Esto incluye usar contraseñas fuertes y únicas para tu
                        cuenta de PWNCAT, habilitar la autenticación de dos factores cuando esté disponible y ser cauteloso al
                        compartir información sensible en línea.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Seguridad de Terceros: Cuando nos relacionamos con proveedores de servicios o socios externos, nos aseguramos
                        de que cumplan con estrictos estándares de seguridad para proteger tus datos. Les exigimos que cumplan con
                        nuestras políticas de seguridad y se adhieran a las regulaciones de protección de datos pertinentes.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        Retención de Datos: Solo retenemos tus datos durante el tiempo necesario para cumplir con los propósitos para
                        los que fueron recopilados. Una vez que los datos ya no son necesarios, los eliminamos de manera segura de acuerdo
                        con nuestras políticas de retención de datos.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text" align="justify">
                    Ten en cuenta que, aunque empleamos estas medidas de seguridad, ninguna plataforma en línea puede garantizar una seguridad absoluta.
                    Las amenazas cibernéticas evolucionan constantemente y nos mantenemos vigilantes en la adaptación de nuestras prácticas de seguridad
                    para abordar nuevos desafíos. Si alguna vez sospechas de problemas de seguridad o tienes preocupaciones sobre tus datos,
                    no dudes en contactarnos en 
                    <MKTypography
                      variant="body2"
                      color="info"
                      component="a"
                      href="mailto:privacy@pwncat.com"
                      target="_blank"
                      rel="noreferrer"
                      sx={{ "&:hover": { color: ({ palette: { info } }) => info.main } }}
                    >
                      &nbsp;privacy@pwncat.com&nbsp;
                    </MKTypography>
                    y investigaremos y abordaremos el problema de inmediato.
                    <br />
                    <br />
                    Tu seguridad es primordial para nosotros y estamos comprometidos a mantener los más altos estándares de
                    ciberseguridad para proteger tu información y garantizar un entorno en línea seguro para nuestros usuarios.
                  </MKTypography>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Pagos
                  </MKTypography>
                  <MKTypography variant="body2" color="text" align="justify">
                    Todos los pagos realizados en nuestra plataforma se procesan de manera segura a través de Redsys. Nos aseguramos de que tu información
                    de pago se maneje con la máxima seguridad y confidencialidad. Redsys emplea protocolos avanzados
                    de cifrado y seguridad para proteger tus datos financieros durante las transacciones.
                    <br />
                    <br />
                    Nuestro sistema de procesamiento de pagos está diseñado para proporcionar una experiencia fluida y segura. Aquí hay algunas características clave:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        <strong>Cifrado:</strong> Todos los datos de pago se cifran utilizando protocolos de cifrado estándar de la industria, asegurando que tu información esté protegida durante la transmisión.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        <strong>Cumplimiento PCI:</strong> Nuestro sistema de procesamiento de pagos cumple con el Estándar de Seguridad de Datos de la Industria de Tarjetas de Pago (PCI DSS), que establece los más altos estándares de seguridad de pagos.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        <strong>Detección de Fraude:</strong> Empleamos mecanismos avanzados de detección de fraude para identificar y prevenir transacciones no autorizadas, asegurando la seguridad de tus datos financieros.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        <strong>Almacenamiento Seguro:</strong> La información de pago se almacena de manera segura en cumplimiento con las regulaciones de protección de datos, asegurando que tus datos estén protegidos contra el acceso no autorizado.
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" align="justify">
                        <strong>Transparencia:</strong> Proporcionamos información clara y transparente sobre todas las transacciones, para que puedas rastrear fácilmente tus pagos y comprender cualquier cargo.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text" align="justify">
                    Si tienes alguna pregunta o inquietud sobre nuestro sistema de procesamiento de pagos, no dudes en contactarnos en 
                    <MKTypography
                      variant="body2"
                      color="info"
                      component="a"
                      href="mailto:payments@pwncat.com"
                      target="_blank"
                      rel="noreferrer"
                      sx={{ "&:hover": { color: ({ palette: { info } }) => info.main } }}
                    >
                      &nbsp;payments@pwncat.com
                    </MKTypography>
                    . Estamos comprometidos a garantizar la seguridad y confidencialidad de tu información financiera.
                  </MKTypography>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default PrivacyPage;